export default __webpack_public_path__ + "static/book-pen-8b768b6adad679c95b7ed204f7186d82.png";